// extracted by mini-css-extract-plugin
module.exports = {"container":"language_selector_dropdown-module--container--3vUKE"};